import { render } from "./Generators.vue?vue&type=template&id=0732f95c"
import script from "./Generators.vue?vue&type=script&lang=js"
export * from "./Generators.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dave/Code/Vue/interim-marketing-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__